"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AccordionItem_1 = __importDefault(require("./AccordionItem"));
var Wrap = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  & > div:first-of-type {\n    border-top: none;\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  & > div:first-of-type {\n    border-top: none;\n  }\n"])));
var Accordion = function (_a) {
    var data = _a.data;
    return (react_1.default.createElement(Wrap, null, data.map(function (itemData, index) { return (
    // eslint-disable-next-line react/no-array-index-key
    react_1.default.createElement(AccordionItem_1.default, { key: index, itemData: itemData })); })));
};
exports.default = Accordion;
var templateObject_1;
